import { lazy, ReactNode, Suspense } from 'react';

import { GetFooterResponse } from 'services/mancity-template/get/types/get-footer.type';
import { GetMainNavResponse } from 'services/mancity-template/get/types/get-main-nav.type';
import { GetPartnerLogosResponse } from 'services/mancity-template/get/types/get-partner-logos.type';

import {
	PUBLIC_FF_HEADER_BASKET_ICON,
	PUBLIC_GTM_ID_ENV,
} from 'tools/environments';

const ManCityTemplate = lazy(() => import('ui/mancity/template'));

type LayoutProps = {
	children: ReactNode;
	footerData?: GetFooterResponse;
	mainNavData?: GetMainNavResponse;
	partnersData?: GetPartnerLogosResponse;
};

const analyticsConfig = {
	gtmId: PUBLIC_GTM_ID_ENV,
};

export const Layout = ({
	children,
	footerData,
	mainNavData,
	partnersData,
}: LayoutProps) => {
	const navItems =
		mainNavData?.find(({ navgroup }) => navgroup === 'primary')?.items ||
		[];

	return (
		<Suspense fallback={null}>
			<>
				<ManCityTemplate
					headerNavigationData={navItems}
					partnersData={partnersData}
					footerData={footerData}
					config={analyticsConfig}
					showBasketIcon={PUBLIC_FF_HEADER_BASKET_ICON}
				>
					{children}
				</ManCityTemplate>
			</>
		</Suspense>
	);
};
